import {showWarning} from "../utils";

export default {
    activeMachines: state => state.activeMachines,
    activeMachinesByProductionLine: (state, getters, rootState) => productionLineId => {
        let productionLine = rootState.productionLines.find(l => l.id == productionLineId);
        if(!productionLine)
            return showWarning(`No existe esa linea de produccion (id ${productionLineId})`)
        if(!productionLine.hasOwnProperty('stations') || !productionLine.stations.length)
            return showWarning(`La unidad de produccion no tiene estaciones`)

        var productionLineMachinesIdList =
            productionLine.stations.map(est => est.machines).flat().map(e => Number(e.id))
        return state.activeMachines.filter(am => productionLineMachinesIdList.includes(Number(am.id)));
    },
    activeMachineById: state => id => state.activeMachines.find(am => am.id == Number(id)),

    productionLinesCollapseStates: state => state.productionLinesCollapseStates,
    productionLineCollapseStateById: state => id => {
        let productionLineCollapseState =  state.productionLinesCollapseStates.find(l => l.id == id);
        if(!productionLineCollapseState)
            return showWarning(`No existe el estado del collapsable (id ${id})`);
        return  productionLineCollapseState? productionLineCollapseState.state:false;
    }
}
